import { required, helpers, sameAs } from 'vuelidate/lib/validators';
import {User} from "@/api/modules/userManagement/models/User";
import {UserManagement} from "@/api/modules/userManagement/UserManagement";
import {StoreProxy} from "@/api/common/StoreProxy";


export default {
    name: "ChangePassword",
    props: {
        user: {
            type: Object,
            required: true,
            default: null
        }
    },
    data() {
        return {
            password: '',
            verifyPassword: '',
            formError: false,
        }
    },
    validations: {
        password: {
            required
        },
        verifyPassword: {
            required,
            sameAsPassword: sameAs('password')
        }
    },
    created() {
        if (this.user == null) {
            throw new Error('[e792115-ADM] Missing user prop. User is null!');
        }

        if (!(this.user instanceof User)) {
            throw new Error('[e832832-ADM] We expect a User object to this component.');
        }
    },
    methods: {
        onSubmit() {

            this.$v.$touch();
            if (this.$v.$invalid) {
                this.formError = true;
                return;
            }

            this.formError = false;

            let vm = this;
            let userManagement = new UserManagement(StoreProxy.getAuth(this.$store));

            userManagement.changePassword(this.user.userId, this.password).then(() => {
                vm.$emit("onSubmitResult", true);
            }).catch(e => {
                vm.$emit("onSubmitResult", false);
            });

        },
        onCancel() {
            this.$emit("cancel")
        }
    },
}